module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-btn-audio-english.fc61d2d4.png";